import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { LoadableHomePage } from '../../scenes/HomePage/LoadableHomePage';

const HomeRouter = ({ defaultRoute, Page403 }) => (
    <Switch>
        <Route exact path="/home" component={LoadableHomePage} Page403={Page403} />
        <Redirect to={defaultRoute} />
    </Switch>
);

HomeRouter.propTypes = {
    defaultRoute: PropTypes.string.isRequired,
    Page403: PropTypes.func.isRequired,
};

export { HomeRouter };
